/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_CroatianInputs */



/**
* | output |
* | --- |
* | "Croatian" |
*
* @param {Speechmatics_Target_Language_CroatianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_croatian = /** @type {((inputs?: Speechmatics_Target_Language_CroatianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_CroatianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Croate")
	if (locale === "de") return /** @type {LocalizedString} */ ("kroatisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("croato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("хорватский")
	if (locale === "es") return /** @type {LocalizedString} */ ("croata")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("克罗地亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クロアチア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्रोएशियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("croata")
	return /** @type {LocalizedString} */ ("Croatian")
});